import { RequireAuthedUser } from '@foxtrotplatform/platform-micro-site-core';
import { Outlet, RouteObject } from 'react-router-dom';

import {
  ApplicationCheck,
  ApplicationCreate,
  ApplicationCredentials,
  ApplicationPublishInput,
  ApplicationPublishSummary,
  ApplicationRoot,
  ApplicationSummary,
  CreatedSuccesfully,
  CreateOrganization,
  HomePage,
  OrganizationDetails,
  OrganizationExists,
  OrganizationProvisioning,
  OrganizationRoot,
  Team,
  TeamManagement,
  VerifyBusiness,
} from './components';
import { ApplicationPublishResult } from './components/Application/ApplicationPublishResult';
import { ContactUs } from './components/ContactUs';
import { Error } from './components/Error';
import { Landing } from './components/Landing';
import { Login } from './components/Login';
import { CreateSolution } from './components/Solution/CreateSolution';
import { EditSolution } from './components/Solution/EditSolution';
import { ListSolutions } from './components/Solution/ListSolutions';
import { SolutionRoot } from './components/Solution/SolutionRoot';
import { SolutionSummary } from './components/Solution/SolutionSummary';

export const routes: RouteObject[] = [
  {
    path: '',
    element: <Landing />,
  },

  {
    path: 'login',
    element: <Login />,
  },

  {
    element: (
      <RequireAuthedUser>
        <Outlet />
      </RequireAuthedUser>
    ),

    children: [
      {
        path: 'home',
        element: <HomePage />,
      },
      {
        path: 'organization',

        children: [
          {
            path: ':organizationId',
            element: <OrganizationDetails />,
          },
          {
            path: 'create',

            element: <CreateOrganization />,
          },
          {
            path: 'exists',

            element: <OrganizationExists />,
          },
          {
            path: ':organizationId/verify',

            element: <VerifyBusiness />,
          },
          {
            path: ':organizationId/success',

            element: <CreatedSuccesfully />,
          },
          {
            path: ':organizationId/provisioning',

            element: <OrganizationProvisioning />,
          },
          {
            index: true,
            element: <OrganizationRoot />,
          },
        ],
      },
      {
        path: 'team',

        children: [
          {
            path: ':id/management',
            element: <TeamManagement />,
          },
          {
            element: <Team />,

            index: true,
          },
        ],
      },
      {
        path: 'application',

        children: [
          {
            path: 'root',
            element: <ApplicationRoot />,
          },
          {
            index: true,
            element: <ApplicationCheck />,
          },
          {
            path: 'check', // Route deprecated. Remove after 2023-12-31.
            element: <ApplicationCheck />,
          },
          {
            path: 'create',
            element: <ApplicationCreate />,
          },
          {
            path: ':applicationId/summary',
            element: <ApplicationSummary />,
          },
          {
            path: ':applicationId/publish',
            element: <ApplicationPublishInput />,
          },
          {
            path: ':applicationId/publish/summary',
            element: <ApplicationPublishSummary />,
          },
          {
            path: ':applicationId/publish/result',
            element: <ApplicationPublishResult />,
          },
          {
            path: ':applicationId/credentials',
            element: <ApplicationCredentials />,
          },
        ],
      },
      {
        path: 'solution',

        children: [
          {
            index: true,
            element: <ListSolutions />,
          },
          {
            path: 'root',
            element: <SolutionRoot />,
          },
          {
            path: 'create',
            element: <CreateSolution />,
          },
          {
            path: ':solutionId',
            element: <SolutionSummary />,
          },
          {
            path: ':solutionId/edit',
            element: <EditSolution />,
          },
        ],
      },
    ],
  },

  { path: 'contact-us', element: <ContactUs /> },
  {
    path: 'error',

    element: <Error />,
  },
];
